import type { GetCourseDetail200SummaryInstructorBasicInfo } from './getCourseDetail200SummaryInstructorBasicInfo';
import type { GetCourseDetail200SummaryInstructorSocial } from './getCourseDetail200SummaryInstructorSocial';

/**
 * 강사 정보
 */
export type GetCourseDetail200SummaryInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: GetCourseDetail200SummaryInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetCourseDetail200SummaryInstructorSocial;
};
